import K_ScreenLayout from "../templates/K_ScreenLayout";
import { Component, ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface ScreenLayoutOptions extends ComponentOptions {
    topToolbar?: Component[];
    leftColumn?: Component[];
    workspace?: Component[];
    subWorkspace?: Component[];
}

export class ScreenLayout extends TemplateComponent {

    options: ScreenLayoutOptions;
    content: {
        topToolbar: Component[];
        leftColumn: Component[];
        workspace: Component[];
        subWorkspace: Component[];
    };
    resizeWindowHandler: () => void;

    constructor(options: ScreenLayoutOptions) {
        super(K_ScreenLayout, options);

        this.content = {
            topToolbar: options.topToolbar || [],
            leftColumn: options.leftColumn || [],
            workspace: options.workspace || [],
            subWorkspace: options.subWorkspace || []
        };
    }

    create() {
        $("#Loader").hide();
        $("#HamburgerMenu").hide();
        this.get(".left-column-menu").hide();

        $("#TopToolbar").fadeTo(0, 1);
        this.get(".left-column").fadeTo(0, 1);

        if (this.content.workspace.length > 0) {
            this.get(".workspace").fadeTo(0, 1);
        }

        if (this.content.subWorkspace.length > 0) {
            this.get(".sub-workspace").fadeTo(0, 1);
        }
    }

}
